import React from 'react';
import styled from 'styled-components/macro';

import { fontDefault, BackButton, breakPoint } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

const ContentTopWrapper = styled.div`
    height: 20px;
    button {
        position: absolute;
    }
    ${os.isOthers ? `
        margin: -45px 0 40px;
        button {
            left: 30px;
            @media only screen and (min-width: ${breakPoint.common.lg}) {
                left: 100px;
            }
        }
        @media only screen and (min-width: ${breakPoint.common.lg}) {
            padding-left: 100px;
        }
    ` : `
        margin: -13px 0 59px;
        button {
            left: 20px;
        }
    `}
`;

const LessonsBackButton = styled(BackButton)`
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    cursor: pointer;
    font-weight: 500;
    font-family: ${fontDefault};
    color: inherit;
    pointer-events: fill;
`;

const ContentTop = props => (
    <ContentTopWrapper>
        <LessonsBackButton onClick={e => props.onBack && props.onBack(e)}>Back</LessonsBackButton>
    </ContentTopWrapper>
);

export default ContentTop;